import { Grid, Stack, Typography } from '@mui/material';
import { LetterCountDTO } from '@/types/letter/LetterCountDTO';
import { OutboxBlock } from '@/components/home/outbox/OutboxBlock';
import { Theme } from '@mui/material/styles';
import { useOutletContext } from 'react-router-dom';
import React, { FC, ReactElement } from 'react';

interface OutletProps {
  outboxCount?: LetterCountDTO;
}

export const MobileOutboxBlock: FC = (): ReactElement => {
  const { outboxCount } = useOutletContext<OutletProps>();

  return (
    <Grid container={true} direction={'column'} spacing={2}>
      <Grid item={true}>
        <Stack direction={'row'} spacing={1}>
          <Typography variant={'h2'} fontSize={'20px'} lineHeight={'24px'} fontWeight={500}>
            {'Исходящие'}
          </Typography>
          {!isNaN(Number(outboxCount?.totalCount)) && (
            <Typography
              variant={'h2'}
              fontSize={'20px'}
              lineHeight={'24px'}
              fontWeight={400}
              sx={{ color: (theme: Theme) => theme.colors.grayText }}>
              {outboxCount?.totalCount}
            </Typography>
          )}
        </Stack>
      </Grid>
      <Grid item={true}>
        <OutboxBlock />
      </Grid>
    </Grid>
  );
};
